import { useState } from 'react';
import { profileUser } from '@/mocks/profile';

const ProfileSettings = () => {
  const [form, setForm] = useState({
    name: profileUser.name,
    email: profileUser.email,
    phone: profileUser.phone,
    birthDate: profileUser.birthDate,
  });
  const [notifications, setNotifications] = useState({ orders: true, promos: true, bonuses: true, news: false });
  const [saved, setSaved] = useState(false);
  const [passwordForm, setPasswordForm] = useState({ current: '', next: '', confirm: '' });

  const handleSave = () => { setSaved(true); setTimeout(() => setSaved(false), 2500); };

  return (
    <div className="space-y-6">
      <h2 className="font-orbitron font-black text-xl text-white">НАСТРОЙКИ</h2>

      {/* Personal info */}
      <div className="rounded-2xl p-6" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)' }}>
        <h3 className="font-orbitron font-bold text-sm text-white mb-5 flex items-center gap-2">
          <i className="ri-user-line" style={{ color: '#ff2d78' }} />
          Личные данные
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[
            { label: 'Имя и фамилия', key: 'name', type: 'text', placeholder: 'Ваше имя' },
            { label: 'Email', key: 'email', type: 'email', placeholder: 'email@example.com' },
            { label: 'Телефон', key: 'phone', type: 'tel', placeholder: '+7 (___) ___-__-__' },
            { label: 'Дата рождения', key: 'birthDate', type: 'date', placeholder: '' },
          ].map(field => (
            <div key={field.key}>
              <label className="font-mono text-[10px] tracking-widest text-white/35 mb-1.5 block">{field.label.toUpperCase()}</label>
              <input
                type={field.type}
                value={form[field.key as keyof typeof form]}
                onChange={e => setForm(f => ({ ...f, [field.key]: e.target.value }))}
                placeholder={field.placeholder}
                className="w-full px-4 py-3 rounded-xl font-mono text-sm text-white bg-transparent outline-none transition-all duration-200"
                style={{ border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.03)' }}
                onFocus={e => (e.target as HTMLInputElement).style.borderColor = 'rgba(255,45,120,0.5)'}
                onBlur={e => (e.target as HTMLInputElement).style.borderColor = 'rgba(255,255,255,0.1)'}
              />
            </div>
          ))}
        </div>
        <div className="mt-5 flex items-center gap-3">
          <button
            onClick={handleSave}
            className="whitespace-nowrap px-6 py-2.5 rounded-xl font-orbitron font-bold text-xs cursor-pointer transition-all duration-300"
            style={saved ? { background: '#39ff14', color: '#050508', boxShadow: '0 0 15px rgba(57,255,20,0.4)' } : { background: '#ff2d78', color: '#fff', boxShadow: '0 0 15px rgba(255,45,120,0.4)' }}
          >
            {saved ? <><i className="ri-check-line mr-1.5" />Сохранено!</> : 'Сохранить изменения'}
          </button>
        </div>
      </div>

      {/* Notifications */}
      <div className="rounded-2xl p-6" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)' }}>
        <h3 className="font-orbitron font-bold text-sm text-white mb-5 flex items-center gap-2">
          <i className="ri-notification-3-line" style={{ color: '#00f5ff' }} />
          Уведомления
        </h3>
        <div className="space-y-4">
          {[
            { key: 'orders', label: 'Статус заказов', sub: 'Уведомления о доставке и изменении статуса', color: '#39ff14' },
            { key: 'promos', label: 'Акции и скидки', sub: 'Персональные предложения и промокоды', color: '#ff2d78' },
            { key: 'bonuses', label: 'Бонусные баллы', sub: 'Начисление и сгорание баллов', color: '#f0ff00' },
            { key: 'news', label: 'Новости аптеки', sub: 'Новинки и полезные статьи', color: '#00f5ff' },
          ].map(n => (
            <div key={n.key} className="flex items-center justify-between gap-4">
              <div>
                <div className="font-mono text-sm text-white/80">{n.label}</div>
                <div className="font-mono text-[11px] text-white/35">{n.sub}</div>
              </div>
              <button
                onClick={() => setNotifications(prev => ({ ...prev, [n.key]: !prev[n.key as keyof typeof prev] }))}
                className="relative w-12 h-6 rounded-full cursor-pointer transition-all duration-300 shrink-0"
                style={{
                  background: notifications[n.key as keyof typeof notifications] ? n.color : 'rgba(255,255,255,0.1)',
                  boxShadow: notifications[n.key as keyof typeof notifications] ? `0 0 10px ${n.color}50` : 'none',
                }}
              >
                <div
                  className="absolute top-1 w-4 h-4 rounded-full transition-all duration-300"
                  style={{
                    background: notifications[n.key as keyof typeof notifications] ? '#050508' : 'rgba(255,255,255,0.4)',
                    left: notifications[n.key as keyof typeof notifications] ? '28px' : '4px',
                  }}
                />
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Change password */}
      <div className="rounded-2xl p-6" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)' }}>
        <h3 className="font-orbitron font-bold text-sm text-white mb-5 flex items-center gap-2">
          <i className="ri-lock-line" style={{ color: '#f0ff00' }} />
          Изменить пароль
        </h3>
        <div className="space-y-3">
          {[
            { label: 'Текущий пароль', key: 'current' },
            { label: 'Новый пароль', key: 'next' },
            { label: 'Подтвердите пароль', key: 'confirm' },
          ].map(f => (
            <div key={f.key}>
              <label className="font-mono text-[10px] tracking-widest text-white/35 mb-1.5 block">{f.label.toUpperCase()}</label>
              <input
                type="password"
                value={passwordForm[f.key as keyof typeof passwordForm]}
                onChange={e => setPasswordForm(p => ({ ...p, [f.key]: e.target.value }))}
                placeholder="••••••••"
                className="w-full px-4 py-3 rounded-xl font-mono text-sm text-white bg-transparent outline-none transition-all duration-200"
                style={{ border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.03)' }}
                onFocus={e => (e.target as HTMLInputElement).style.borderColor = 'rgba(240,255,0,0.4)'}
                onBlur={e => (e.target as HTMLInputElement).style.borderColor = 'rgba(255,255,255,0.1)'}
              />
            </div>
          ))}
          <button className="whitespace-nowrap mt-2 px-6 py-2.5 rounded-xl font-orbitron font-bold text-xs cursor-pointer transition-all duration-300" style={{ border: '1px solid rgba(240,255,0,0.3)', color: '#f0ff00' }}>
            Сменить пароль
          </button>
        </div>
      </div>

      {/* Danger zone */}
      <div className="rounded-2xl p-6" style={{ background: 'rgba(255,45,120,0.03)', border: '1px solid rgba(255,45,120,0.15)' }}>
        <h3 className="font-orbitron font-bold text-sm mb-3 flex items-center gap-2" style={{ color: '#ff2d78' }}>
          <i className="ri-error-warning-line" />
          Опасная зона
        </h3>
        <p className="font-mono text-xs text-white/35 mb-4">Удаление аккаунта необратимо. Все данные, заказы и бонусные баллы будут удалены.</p>
        <button className="whitespace-nowrap px-5 py-2.5 rounded-xl font-mono text-xs cursor-pointer transition-all duration-200" style={{ border: '1px solid rgba(255,45,120,0.3)', color: '#ff2d78' }}>
          Удалить аккаунт
        </button>
      </div>
    </div>
  );
};

export default ProfileSettings;
